var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3307 16.0013C29.3307 23.3651 23.3612 29.3346 15.9974 29.3346C8.6336 29.3346 2.66406 23.3651 2.66406 16.0013C2.66406 8.63751 8.6336 2.66797 15.9974 2.66797C23.3612 2.66797 29.3307 8.63751 29.3307 16.0013Z",
    fill: "#FF6363"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.957 11.9609C12.3475 11.5703 12.9806 11.5703 13.3712 11.9609L15.9974 14.5871L18.6236 11.9609C19.0141 11.5704 19.6473 11.5704 20.0378 11.9609C20.4284 12.3514 20.4284 12.9846 20.0378 13.3751L17.4116 16.0013L20.0378 18.6275C20.4283 19.018 20.4283 19.6512 20.0378 20.0417C19.6473 20.4322 19.0141 20.4322 18.6236 20.0417L15.9974 17.4155L13.3712 20.0417C12.9807 20.4323 12.3475 20.4323 11.957 20.0417C11.5665 19.6512 11.5665 19.0181 11.957 18.6275L14.5832 16.0013L11.957 13.3751C11.5664 12.9846 11.5664 12.3514 11.957 11.9609Z",
    fill: "#FFA0A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.b95e22ebe265edbde4421ed9b8e90cc9.svg";
export { ForwardRef as ReactComponent };